module.exports = __webpack_public_path__ + "assets/img/calendar-white.9465b27f.svg";